(function () {
    'use strict';

    angular
        .module('vctodo')
        .config(config);

    config.$inject = ['$stateProvider', '$logProvider'];

    function config($stateProvider, $log) {
        $stateProvider
            .state('playground.vctodo', {
                url: '/vctodo',
                views: {
                    'playgroundmain@playground': {
                        template: `
              <h3 class="alert alert-info"><tt>&lt;todowidget&gt;</tt></h3><div ui-view="todowidget"></div>
            `
                    }
                },
                onEnter: function ($log) {
                    $log.debug('debug/routes - playground.vctodo entered');
                }
            });
        $stateProvider
            .state('playground.vctodo.allcomponents', {
                url: '/allcomponents',
                resolve: {
                    todo: function () {
                        return '';
                    },
                },
                views: {
                    // When `fooState.barState` is active, `fooComponent`
                    // is loaded into the <ui-view name='content' />
                    // which was created by `fooState`.
                    // The component's `foo` input receives `fooData` resolve
                    'todowidget@playground.vctodo': {
                        component: 'todowidget',
                    }
                },
                onEnter: function () {
                    console.log('playground.vctodo.allcomponents entered');
                }
            });


    }// all routes


}());